import clamp from 'lodash/clamp';
import {useRef} from 'react';
import {twMerge} from '../../../common/twMerge';
import {useSeekbarHandler} from '../../../domain/content/[seriesId]/viewer/[productId]/hook/useSeekbarHandler';
import {SliderProps} from './SliderProps.interface';

/**
 * Slider의 value값은 0~1이어야 합니다.
 */

export function Slider({
  isMobile,
  loadedValue = 0,
  currentValue,
  hasIndicator = true,
  onValueChange,
  onPressSlider,
  onReleaseSlider,
  barStyleClassName,
  loadStyleClassName,
  valueStyleClassName,
  indicatorStyleClassName,
  className,
  ...props
}: SliderProps) {
  const sliderBarRef = useRef<HTMLDivElement>(null);

  const {handlePressSeekbar, handleReleaseSeekbar} = useSeekbarHandler({
    seekbarRef: sliderBarRef,
    onProgressChange: onValueChange,
    onReleaseSeekbar: onReleaseSlider,
    onPressSeekbar: onPressSlider,
  });

  return (
    <div
      ref={sliderBarRef}
      className={twMerge(
        'flex h-18pxr flex-1 items-center bg-transparent',
        !isMobile && 'cursor-pointer',
        className
      )}
      onMouseDown={handlePressSeekbar}
      onTouchStart={handlePressSeekbar}
      onTouchEnd={handleReleaseSeekbar}
      {...props}
    >
      <div
        className={twMerge(
          'relative h-2pxr w-full rounded-[2px] bg-theme-transparent-20',
          !isMobile && 'cursor-pointer',
          barStyleClassName
        )}
      >
        <div
          className={twMerge(
            'absolute top-0 left-0 h-full rounded-[2px] bg-theme-transparent-10',
            loadStyleClassName
          )}
          style={{
            width: `${clamp(loadedValue * 100, 0, 100)}%`,
          }}
        />
        <div
          className={twMerge(
            'relative h-full rounded-[2px] bg-theme-solid-100',
            valueStyleClassName
          )}
          style={{
            width: `${clamp(currentValue * 100, 0, 100)}%`,
          }}
        >
          {hasIndicator && (
            <div
              className={twMerge(
                'absolute -top-14pxr -right-15pxr flex h-30pxr w-30pxr items-center justify-center',
                !isMobile && 'cursor-pointer'
              )}
              onClick={e => e.stopPropagation()}
            >
              <div
                className={twMerge(
                  'h-12pxr w-12pxr rounded-full bg-theme-solid-100',
                  indicatorStyleClassName
                )}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
